export function fotoUrl(usuario, cacheKey = null) {
  if (!usuario?.foto_url) return null;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const suffix = cacheKey != null ? `?v=${cacheKey}` : "";
  return `${base}${usuario.foto_url}${suffix}`;
}
